<template>
  <user-locations />
</template>

<script>
import UserLocations from "@/components/Ondemand/Locations/Locations.vue";

export default {
  components: {
    UserLocations,
  },
};
</script>

<style></style>
